import { Models } from '$models';

type FreddieMacFields = Pick<Models.PropertyDetailsResponse, 'PROGRAMRECORDTYPE' | 'PROGRAM_NAME' | 'CYCLE'>;

export function isFreddieMacProperty(property?: FreddieMacFields | null): boolean {
  if (!property) {
    return false;
  }
  const { PROGRAMRECORDTYPE, PROGRAM_NAME, CYCLE } = property;
  const isFreddieMacProgram =
    PROGRAMRECORDTYPE === Models.ProgramRecordType.FIRST_LOOK ||
    PROGRAMRECORDTYPE === Models.ProgramRecordType.DAY_1 ||
    PROGRAM_NAME === Models.ProgramRecordType.DAY_1;

  // First Look restrictions apply only during the first auction cycle.
  return isFreddieMacProgram && CYCLE === Models.FIRST_LOOK_CYCLE;
}
